module.exports = __webpack_public_path__ + "media/components/shared/static/gallery-white-4c8a26ee8a1db3b7d48fce948bf5f46a.svg";